module.exports = __webpack_public_path__ + "img/refresh.6355c0bf.svg";